import React, { useState, useEffect, useMemo } from 'react';
import api from '../../config/api';
import { parseYMD, MONTH_NAMES, isTodayMonthDay } from '../../utils/dateUtils';
import styles from './BirthdaysPage.module.css';

const BirthdaysPage = () => {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [monthIndex, setMonthIndex] = useState(new Date().getMonth());

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res = await api.getAllEmployees();
        if (res.success) setEmployees(res.data);
      } catch { /* ignore — empty list falls back to "no birthdays" state */ }
      finally { setLoading(false); }
    })();
  }, []);

  const monthBirthdays = useMemo(() => {
    return employees
      .filter((e) => e.isActive && e.dateOfBirth)
      .map((e) => ({ ...e, parsed: parseYMD(e.dateOfBirth) }))
      .filter((e) => e.parsed.month === monthIndex)
      .sort((a, b) => a.parsed.day - b.parsed.day);
  }, [employees, monthIndex]);

  const goPrevMonth = () => setMonthIndex((m) => (m + 11) % 12);
  const goNextMonth = () => setMonthIndex((m) => (m + 1) % 12);
  const goThisMonth = () => setMonthIndex(new Date().getMonth());

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <div className={styles.pageTitle}>🎂 Birthdays</div>
      </div>

      <div className={styles.monthNav}>
        <button className={styles.navBtn} onClick={goPrevMonth} aria-label="Previous month">←</button>
        <div className={styles.monthLabel}>
          {MONTH_NAMES[monthIndex]}
          {monthIndex !== new Date().getMonth() && (
            <button className={styles.todayLink} onClick={goThisMonth}>This month</button>
          )}
        </div>
        <button className={styles.navBtn} onClick={goNextMonth} aria-label="Next month">→</button>
      </div>

      {loading ? (
        <div className={styles.loading}>Loading birthdays...</div>
      ) : monthBirthdays.length === 0 ? (
        <div className={styles.emptyState}>No birthdays in {MONTH_NAMES[monthIndex]}.</div>
      ) : (
        <div className={styles.grid}>
          {monthBirthdays.map((e) => {
            const today = isTodayMonthDay(e.dateOfBirth);
            return (
              <div key={e.id} className={`${styles.card} ${today ? styles.today : ''}`}>
                {today && <div className={styles.todayBadge}>🎉 Today</div>}
                <div className={styles.avatar}>🎂</div>
                <div className={styles.name}>{e.name}</div>
                <div className={styles.date}>{e.parsed.day} {MONTH_NAMES[monthIndex].slice(0, 3)}</div>
                <div className={styles.dept}>{e.department}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default BirthdaysPage;
